export let versionsFields = {
    id: "id",
    platform: "platform",
    appType: "app_type",
    version: "version",
    forceUpdate: "force_update",
    build: "build",
    releaseNotes: "release_notes"  
};
